export type Hardware= {
    hardware_id: string,
    hardware_station: string ,
    hardware_connector: string,
    hardware_charge_point: string,
    hardware_created_at: string,
    hardware_updated_at: string,//2024-12-23T14:13:03.120314Z,
    hardware_created_by: string,
    hardware_type: HardwaresType,
    hardware_device_id: string,
    hardware_secret_key: string,
    hardware_secret_key_credit: string,
}

export type HardwarePatch = Partial<Hardware>; 

export type HardwaresType = 'STATION' | 'CONNECTOR' | 'CHARGEPOINT';

export const translateHardwaresType = (type: HardwaresType) => {
    switch (type) {
        case "STATION":
            return "Station"
        case "CONNECTOR":
            return "Connecteur"
        case "CHARGEPOINT":
            return "Borne"
        default:
            return type
    }
}